import { create } from 'zustand'

/**
 * Subscription-level billing block (HTTP 421, codes 0-3). Set by the httpClient
 * interceptor; a top-level gate renders the recovery screen while it is set.
 * Not persisted — it must re-derive from live API responses each session.
 */
export interface BillingBlock {
  code: number
  message: string
}

interface BillingStoreState {
  block: BillingBlock | null
  setBlock: (block: BillingBlock) => void
  clearBlock: () => void
}

const useBillingStore = create<BillingStoreState>((set) => ({
  block: null,
  setBlock: (block) => set({ block }),
  clearBlock: () => set({ block: null }),
}))

export default useBillingStore
